import { Bounds, CenterCoordinate } from '@m/types/MapTypes';
import { createEvent } from 'effector';

export const setIsUpcomingSubExpanded = createEvent<boolean>();
export const setBounds = createEvent<Bounds>();
export const setCenterCoordinate = createEvent<CenterCoordinate>();

export const setIndividualSubscriptionInvitationId = createEvent<string | null>();
